import { ChatTopicWrapper } from 'applications/GSP/pages/ParentHelper/components/History/components/Content/components/ChatTopicWrapper';
import { ChatTopicsWrapper } from 'applications/GSP/pages/ParentHelper/components/History/components/Content/components/ChatTopicsWrapper';
import { List } from 'shared/components/List';
import { ListItemText } from 'shared/components/ListItem';
import { Skeleton as SkeletonItem } from 'shared/components/Skeleton';

export const Skeleton = () => (
  <ChatTopicsWrapper title={<SkeletonItem width={120} height={12} />}>
    <List disablePadding>
      <ChatTopicWrapper sx={{ mt: 1 }}>
        <ListItemText>
          <SkeletonItem sx={{ mt: 0.75 }} width={120} height={12} />
          <SkeletonItem sx={{ mt: 1.25, mb: 0.5 }} width={60} height={12} />
        </ListItemText>
      </ChatTopicWrapper>
    </List>
  </ChatTopicsWrapper>
);
